import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { AppBar, Typography } from '@material-ui/core';
import axiosInstance from '../../axios/axios-instance';
import { clearStoreLogout } from '../../modules/login-reducer';
import { useDispatch } from 'react-redux';
import NavItem from '../../common/List/NavItem';
import CloseIcon from '@material-ui/icons/Close';
import MenuIcon from '@material-ui/icons/Menu';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import theme, { mainFont } from '../../theme';
import IconButton from '@material-ui/core/IconButton';
import Notifications from '../Notifications/Notifications';
import Drawer from '@material-ui/core/Drawer';
import HomeIcon from '@material-ui/icons/Home';

import logo from './logo.png';

// import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import clsx from 'clsx';
import {
	makeStyles,
	useTheme,
	Theme,
	createStyles,
} from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import AssignmentIcon from '@material-ui/icons/Assignment';
import FingerprintIcon from '@material-ui/icons/Fingerprint';
import GroupIcon from '@material-ui/icons/Group';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ChatRoom from '../ChatRoom/ChatRoom';

const font = "'Audiowide', cursive";

const drawerWidth = 240;

const useMUIStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {},
		menuButton: {
			marginRight: theme.spacing(2),
			color: theme.palette.common.white,
		},
		hide: {
			display: 'none',
		},
		drawer: {
			width: drawerWidth,
			flexShrink: 0,
		},
		drawerPaper: {
			width: drawerWidth,
			backgroundColor: theme.palette.grey[800],
			boxShadow: `1px 1px 3px 1px ${theme.palette.grey[900]}`
		},
		drawerHeader: {
			alignItems: 'center',
			backgroundColor: theme.palette.grey[700],
		},
		closeDrawerButton: {
			color: theme.palette.common.white,
			float: 'right'
		},
		content: {
			flexGrow: 1,
			padding: theme.spacing(3),
			transition: theme.transitions.create('margin', {
				easing: theme.transitions.easing.sharp,
				duration: theme.transitions.duration.leavingScreen,
			}),
			marginLeft: -drawerWidth,
		},
		contentShift: {
			transition: theme.transitions.create('margin', {
				easing: theme.transitions.easing.easeOut,
				duration: theme.transitions.duration.enteringScreen,
			}),
			marginLeft: 0,
		},
	})
);

const useStyles = makeStyles({
	header: {
		padding: '10px 0px',
		backgroundColor: theme.palette.secondary.dark,
	},
	headerLogo: {
		cursor: 'pointer',
		textAlign: 'center',
	},
	logoWrapper: {
		// margin: '0px 100px',
		display: 'inline-block',
		verticalAlign: 'middle',
		marginRight: '20px'
		// backgroundColor: 'white'
	},
	headerImg: {
		width: '40px',
		height: 'auto',
		float: 'left',
	},
	headerTitle: {
		fontFamily: font,
		cursor: 'pointer',
		height: 'auto',
		width: 'auto',
		float: 'left',
		padding: '6px 0px 0px 5px'
		// height: '100%',
		// lineHeight: '50px',
	},
	headerButtons: {
		width: '100px',
		height: '50px',
	},
	headerList: {
		textAlign: 'center',
		padding: '0px 0px',
	},
	dropdownList: {
		padding: theme.spacing(2),
		position: 'relative',
		float: 'inline-start',
		height: '100%'
	},
	welcome: {
		float: 'left',
		paddingLeft: '20px',
		fontFamily: mainFont
	}
});

const WaffleHeader = () => {
	const classes = useStyles();
	const muiClasses = useMUIStyles();
	const dispatch = useDispatch();
	const history = useHistory();
	const showLogin = localStorage.getItem('token') === '';
	const [open, setOpen] = React.useState(false);
	const [selectedPath, setSelectedPath] = React.useState('/');

	const handleDrawerOpen = () => {
		setOpen(true);
	};

	const handleDrawerClose = () => {
		setOpen(false);
	};

	const handleLogout = () => {
		handleDrawerClose();
		axiosInstance.defaults.headers.common.Authorization = '';
		dispatch(clearStoreLogout());
		localStorage.removeItem('token');
		// history.push('/Login');
	};

	React.useEffect(() => {
		return history.listen((location => {
			let path: string = ''
			path += location.pathname[0];
			for (let i = 1; i < location.pathname.length; i++) {
				path += location.pathname[i];
				if (location.pathname[i] === '/') {
					break;
				}
			}
			handleDrawerClose();
			setSelectedPath(path)
		}))
	}, [history])

	return (
		<>
			<AppBar position='static' className={`${classes.header}`}>
				<Grid
					alignItems='center'
					container
					// xs={12}
					spacing={0}
					className={classes.headerList}
				>
					<Grid item xs={3}>
						<IconButton
							aria-label='open drawer'
							onClick={handleDrawerOpen}
							edge='start'
							className={clsx(
								muiClasses.menuButton,
								open && muiClasses.hide
							)}
						>
							<MenuIcon fontSize='large' />
						</IconButton>
					</Grid>
					<Grid item xs={6} className={classes.headerLogo}>
						<Box
							className={classes.logoWrapper}
							onClick={() => history.push('/')}
						>
							{/* Logo goes here */}
							<img
								src={logo}
								className={classes.headerImg}
							/>
							<Typography
							onClick={() => history.push('/')}
								variant='h5'
								className={classes.headerTitle}
							>
								COSINT
							</Typography>
						</Box>
					</Grid>
					<Grid item xs={1}>
						<ChatRoom />
					</Grid>
					<Grid item xs={2}>
						<Notifications />
					</Grid>
				</Grid>

				<Drawer
					className={muiClasses.drawer}
					variant='persistent'
					anchor='left'
					open={open}
					classes={{
						paper: muiClasses.drawerPaper,
					}}
				>
					<Grid container className={muiClasses.drawerHeader}>
						<Grid item xs={10}>
							<Typography variant='subtitle1' className={classes.welcome}>Hello {localStorage.getItem("firstName") || 'friend'}</Typography>
						</Grid>
						<Grid item xs={2}>

						<IconButton
							onClick={handleDrawerClose}
							className={muiClasses.closeDrawerButton}
							>
							{theme.direction === 'ltr' ? (
								<ChevronLeftIcon />
								) : (
									<ChevronRightIcon />
									)}
						</IconButton>
									</Grid>
					</Grid>

					<List
						component='nav'
						aria-label='options-list'
						className={`${classes.dropdownList}`}
					>
						{showLogin ? (
							<>
							<NavItem
								selectedPath={selectedPath}
								path={'/Login'}
								text='Login'
								special={false}
								onClick={handleLogout}
							/>
							<NavItem
								selectedPath={selectedPath}
								path={'/SignUp'}
								text='Sign Up'
								special={true}
							/>
							</>
						) : (
							<>
								<NavItem
									selectedPath={selectedPath}
									path='/'
									text='Home'
									icon={<HomeIcon />}
								/>
								{/* <NavItem
									selectedPath={selectedPath}
									path='/Tasks'
									text='Tasks'
									icon={<AssignmentIcon />}
								/> */}
								<NavItem
									selectedPath={selectedPath}
									path='/Investigations'
									text='Investigations'
									icon={<FingerprintIcon />}
									// icon={<ImageSearchIcon />}
								/>
								<NavItem
									selectedPath={selectedPath}
									path='/Experts'
									text='Experts'
									icon={<AssignmentIndIcon />}
								/>
								<NavItem
									selectedPath={selectedPath}
									path='/Teams'
									text='Teams'
									icon={<GroupIcon />}
								/>
								<NavItem
									selectedPath={selectedPath}
									path='/'
									special={true}
									text='Logout'
									onClick={handleLogout}
									icon={<ExitToAppIcon />}
								/>
							</>
						)}
					</List>
				</Drawer>
			</AppBar>
		</>
	);
};

export default WaffleHeader;
